import Vue from "vue";
import Vue2Filters from "vue2-filters";
import PortalVue from "portal-vue";
import VueLodash from "vue-lodash";
import lodash from "lodash";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import rate from "vue-rate";
import "vue-rate/dist/vue-rate.css";
import VueSocialSharing from "vue-social-sharing";
import VueCurrencyInput from "vue-currency-input";
import VueGtm from "vue-gtm";
import VueAxios from "vue-axios";
import axios from "axios";
import VueHtml2Canvas from "vue-html2canvas";
import StepBulletPersonal from "@/components/common/StepBulletPersonal.vue";
import StepBulletCorporation from "@/components/common/StepBulletCorporation.vue";
import TemplatePersonal from "@/components/TemplatePersonal.vue";
import TemplateCorporation from "@/components/TemplateCorporation.vue";
import TemplateForm from "@/components/TemplateForm.vue";
import TemplateInfo from "@/components/TemplateInfo.vue";
import BackButton from "@/components/common/BackButton.vue";
import ChevronRightLink from "@/components/common/ChevronRightLink.vue";
import ExternalLink from "@/components/common/ExternalLink.vue";
import Button from "@/components/common/Button.vue";
import QuestionTemplate from "@/components/QuestionTemplate.vue";
import Currency from "@/components/common/Currency.vue";
import Dropdown from "@/components/common/Dropdown.vue";
import Percentage from "@/components/common/Percentage.vue";
import VueLocalStorage from "vue-localstorage";
import Modal from "@/components/Modal.vue";
import Loading from "@/components/common/Loading.vue";
import EXTERNAL_LINK_CONFIG from "@/configs/external_link_config.json";
Vue.config.productionTip = false;

Vue.use(VueLocalStorage, { name: "ls" });
Vue.use(Vue2Filters);
Vue.use(PortalVue);
Vue.use(rate);
Vue.use(VueSocialSharing);
Vue.use(VueLodash, { name: "custom", lodash: lodash });
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: null,
    precision: 0,
    valueRange: { min: 0, max: 9999999999.99 },
  },
});
Vue.use(VueAxios, axios);
Vue.use(VueHtml2Canvas);
Vue.use(VueGtm, {
  id: [process.env.VUE_APP_GTM_KEY], // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  // debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});
Vue.component("step-bullet-personal", StepBulletPersonal);
Vue.component("step-bullet-corporation", StepBulletCorporation);
Vue.component("template-personal", TemplatePersonal);
Vue.component("template-corporation", TemplateCorporation);
Vue.component("template-form", TemplateForm);
Vue.component("template-info", TemplateInfo);
Vue.component("back-button", BackButton);
Vue.component("material-button", Button);
Vue.component("chevron-right-link", ChevronRightLink);
Vue.component("external-link", ExternalLink);
Vue.component("question-template", QuestionTemplate);
Vue.component("currency", Currency);
Vue.component("dropdown", Dropdown);
Vue.component("percentage", Percentage);
Vue.component("modal", Modal);
Vue.component("loading", Loading);

Vue.mixin({
  methods: {
    goToDoc1() {
      window.open(EXTERNAL_LINK_CONFIG.PND_1, "_blank");
    },
    goToDoc1a() {
      window.open(EXTERNAL_LINK_CONFIG.PND_1A, "_blank");
    },
    goToDoc3() {
      window.open(EXTERNAL_LINK_CONFIG.PND_3, "_blank");
    },
    goToDoc30() {
      window.open(EXTERNAL_LINK_CONFIG.PP_30, "_blank");
    },
    goToDoc50() {
      window.open(EXTERNAL_LINK_CONFIG.PND_50, "_blank");
    },
    goToDoc51() {
      window.open(EXTERNAL_LINK_CONFIG.PND_51, "_blank");
    },
    goToDoc53() {
      window.open(EXTERNAL_LINK_CONFIG.PND_53, "_blank");
    },
    goToDoc90() {
      window.open(EXTERNAL_LINK_CONFIG.PND_90, "_blank");
    },
    goToDoc91() {
      window.open(EXTERNAL_LINK_CONFIG.PND_91, "_blank");
    },
    goToDoc94() {
      window.open(EXTERNAL_LINK_CONFIG.PND_94, "_blank");
    },
    goToDoc01() {
      window.open(EXTERNAL_LINK_CONFIG.PP_01, "_blank");
    },
    goToDoc01_1() {
      window.open(EXTERNAL_LINK_CONFIG.PP_01_1, "_blank");
    },
    goToDocPowerOfAttorney() {
      window.open(EXTERNAL_LINK_CONFIG.DOC_POWER_OF_ATTORNEY, "_blank");
      //มอบอำนาจ
    },
    goToDocCommercialRegistration() {
      //ใบทะเบียนพาณิชย์
      window.open(EXTERNAL_LINK_CONFIG.DOC_COMMERCIAL_REGISTER, "_blank");
    },
    goToDocCertificate() {
      //หนังสือรับรองการจดทะเบียนหุ้นส่วนบริษัท
      window.open(EXTERNAL_LINK_CONFIG.DOC_CERTIFICATE, "_blank");
    },
    goToExcerpVat() {
      //กรณียกเว้นไม่ต้องจด VAT
      window.open(EXTERNAL_LINK_CONFIG.EXCERP_VAT, "_blank");
    },
    goToDoc20() {
      //ภ.พ. 20
      window.open(EXTERNAL_LINK_CONFIG.PP_20, "_blank");
    },
    goToOnlineRegister() {
      window.open(EXTERNAL_LINK_CONFIG.ONLINE_REGISTER, "_blank");
    },
    exampleDoc() {
      window.open(EXTERNAL_LINK_CONFIG.EXAMPLE_DOC, "_blank");
    },
    eFiling() {
      window.open(EXTERNAL_LINK_CONFIG.E_FILING, "_blank");
    },
    lp10_1() {
      window.open(EXTERNAL_LINK_CONFIG.LP10_1, "_blank");
    },
    lp10_2() {
      window.open(EXTERNAL_LINK_CONFIG.LP10_2, "_blank");
    },
    goTermAndCondition() {
      this.$router.push({ path: "/disclaimer" });
    },
    vatOnline() {
      window.open(EXTERNAL_LINK_CONFIG.VAT_ONLINE, "_blank");
    },
    goSsoOnline() {
      window.open(EXTERNAL_LINK_CONFIG.SSO_ONLINE, "_blank");
    },
    cloudAccounting() {
      window.open(EXTERNAL_LINK_CONFIG.CLOUD_ACCOUNTING, "_blank");
    },
    getHostUrl() {
      return process.env.VUE_APP_HOST_URL;
    },
  },
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
